
import { Assessment } from '@/types/assessment';
import { createServiceClient } from '@/services/migration/serviceClient';
import { getAssessmentById } from './getAssessments';

// Archive an assessment
export const archiveAssessment = async (id: string): Promise<Assessment | null> => {
  try {
    // Use service client to bypass RLS policies
    const serviceClient = createServiceClient();
    
    // Update assessment status to archived
    const { error } = await serviceClient
      .from('assessments')
      .update({
        is_active: false,
        status: 'archived',
        updated_at: new Date().toISOString()
      })
      .eq('id', id);
      
    if (error) {
      console.error('Error archiving assessment:', error);
      throw error;
    }
    
    // Get the updated assessment
    return await getAssessmentById(id);
  } catch (error) {
    console.error('Error in archiveAssessment:', error);
    throw error;
  }
};

// Restore an archived assessment
export const restoreArchivedAssessment = async (id: string): Promise<Assessment | null> => {
  try {
    // Use service client to bypass RLS policies
    const serviceClient = createServiceClient();
    
    // Get the assessment first to check status
    const currentAssessment = await getAssessmentById(id);
    if (!currentAssessment || currentAssessment.status !== 'archived') {
      return null;
    }
    
    // Update assessment status to published
    const { error } = await serviceClient
      .from('assessments')
      .update({
        is_active: true,
        status: 'published',
        updated_at: new Date().toISOString()
      })
      .eq('id', id);
      
    if (error) {
      console.error('Error restoring assessment:', error);
      throw error;
    }
    
    // Get the updated assessment
    return await getAssessmentById(id);
  } catch (error) {
    console.error('Error in restoreArchivedAssessment:', error);
    throw error;
  }
};
